module.exports = "/_next/static/images/c89236e4623d042b9db3161abb2fc3e2-pj-person-making-card-purchase@1x.jpg";